<template>
  <v-chip
      class="ma-2"
      :color="color"
      text-color="white"
      variant="flat"
  >
    <v-icon left :title="title">{{ speed.toFixed(1) }} km/h</v-icon>
  </v-chip>
</template>

<script>
    export default {
        name: 'SpeedIndex',
        props: {
          speed: {
            type: Number,
            default: 4.5
          },
        },
      data: function () {
        return {
          lowSpeed: 3.8,
          highSpeed: 5.5
        }
      },
        computed: {
          color () {
            if (this.speed < this.lowSpeed) {
              return 'orange'
            } else if (this.speed > this.highSpeed) {
              return 'blue'
            }
            return 'green'
          },
          title () {
            if (this.speed < this.lowSpeed) {
              return 'Langsam'
            } else if (this.speed > this.highSpeed) {
              return 'Schnell'
            }
            return 'Normal'
          }
        }
    }
</script>
